import AppModal from "components/Modal"; 
import React, {  
    useState, 
}  from 'react';
import ReactDOM from "react-dom"; 
import { useAuth } from '../../../helpers/authContext';

import {
    // Alert,
    Button, 
  Card,
  CardBody,
} from "reactstrap"; 
import { useToast } from "components/ui/use-toast"; 
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal"; 
import { isLoggedWithKeychain } from "services/dsteem-service";
import { cancelWithdrawFromSavingsKeychain  } from "helpers/keychain";
import { cancelWithdrawFromSavingsWithWif } from "helpers/steem"; 
type Props = {
  isShowing: boolean,
  hide: any, 
  request_id?:any,
  onSuccess?: () => void;
}

export const CancelWithdrawFromSavingsModal = ({ isShowing, hide,  request_id=null, onSuccess = null}: Props) => { 
    const { user, autologin } = useAuth(); 
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const [isTransferring, setIsTransferring] = useState(false); 
    const keychainLogin = isLoggedWithKeychain(autologin);  
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast(); 


    const handleTransfer = async (newWif = "") => { 
        if (request_id) { 
            const fn = keychainLogin ? cancelWithdrawFromSavingsKeychain : cancelWithdrawFromSavingsWithWif;
            const account = keychainLogin ? user : autologin; 
            setIsTransferring(true);
            let res:any = await fn(account, request_id, newWif);
            setIsTransferring(false);
            if (!res.success) { 
                if(res?.message.toString().includes("Missing Active Authority")){ 
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                } else {
                   toast({
                        title:"Failed canceling request.",
                        description:res,
                        variant:"rose_red"
                    }); 
                }
                
            }else {
                toast({
                title:"Withdraw request cancelled successfully.",
                description:"Your request have been stopped.",
                variant:"wild_green"
                });  
                if (onSuccess) {
                    onSuccess();
                }
                
                hide();
            }
        }else{
            toast({
                title:"Failed canceling request.",
                description:"Missing request id.",
                variant:"rose_red"
            });
        }
    }
    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0">
            {user && (
                <CardBody className="px-lg-3 py-lg-4 body-gray">  
                    <div className="p-1 text-scheme">
                        <p className="text-muted mb-4">You are about to cancel a savings withdrawal request. This action cannot be undone.</p>
                        <div className="mb-4 p-3 border rounded bg-speem-confirm">
                            <div className="mb-2">
                                <i className="fas fa-hashtag mr-2 text-speem" /> <strong>Request ID:</strong> <span className="ml-2">{request_id}</span>
                            </div>
                            <div className="mb-0">
                                <i className="fas fa-university mr-2 text-speem" /> <strong>Source:</strong> <span className="ml-2">Savings balance</span>
                            </div>
                        </div>
                        <div className="d-flex gap-3 mt-4">
                            <Button color="secondary" onClick={hide} disabled={isTransferring} className="w-100 mr-2 btn-fancy">
                                Keep Withdrawal
                            </Button>
                            <Button color="danger" onClick={() => handleTransfer()} disabled={isTransferring} className="w-100 btn-fancy position-relative">
                                {isTransferring ? (
                                    <span className="spinner dark m-0" />
                                ) : keychainLogin ? (
                                    <>
                                    Cancel with
                                    <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" />
                                    </>
                                ) : (
                                    "Confirm"
                                )}
                            </Button>
                        </div>
                    </div>
                </CardBody>
            )}
            {!user && (<p>Please log in to transfer funds.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header="Cancel Savings Withdrawal"
        >
            {renderForm}
        </AppModal>
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => { 
                if (wif) {
                handleTransfer(wif);
                } 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default CancelWithdrawFromSavingsModal;